const messages = {
    de: {
        account: {
            account_settings: 'Account Einstellungen',
            change_email: 'E-Mail-Adresse ändern',
            change_email_info: 'Gib deine neue E-Mail-Adresse unten ein. <br>Wir senden eine E-Mail an die neue Adresse mit der Bitte deinen Account zu verifizieren.',
            delete_account: 'Account löschen',
            delete_account_info: {
                header: 'Diese Aktion wird dein Konto und deine persönlichen Daten endgültig löschen.',
                body: 'Zu den Daten, die gelöscht werden, gehören:',
                list: [
                    'Deine persönlichen Daten',
                    'Bewerbungen auf Stellen in unserem System (keine Daten, die ein Arbeitgeber möglicherweise heruntergeladen hat)',
                    'Lebensläufe, auch aus der Arbeitgeber-Bewerbersuche',
                    'E-Mail-Abonnements zu Marketing und Job Benachrichtigungen',
                ],
                footer: 'Du kannst dir anschließend einen neuen Account eröffnen.',
            },
            delete_confirmation: 'Bist du dir sicher? Diese Aktion kann nicht rückgängig gemacht werden.',
            delete_success_title: 'Es tut uns leid, dich gehen zu sehen :(',
            delete_success_message: 'Dein Account wurde erfolgreich gelöscht. Wir melden dich jetzt ab.',
            enter_code: 'Code eingeben',
            resend_code: 'Hier klicken, um den Code erneut anzufordern',
            reset_password: 'Passwort zurücksetzen',
            reset_password_info: 'Klicke den Button unten und wir senden dir einen Code zum Zurücksetzen deines Passworts. Du wirst dann aufgefordert, ein neues Passwort zu erstellen!',
            reset_password_success: 'Wir haben dir einen Code zum Zurücksetzen deines Passworts an deine aktuelle E-Mail-Adresse gesendet. Bitte prüfe auch deinen Spam-Ordner. Klicke hier, um den Code erneut anzufordern.',
            try_again: 'bitte versuchen Sie es in 10 Minuten erneut.',
        },

        api_message: {
            UserTokenNotFoundException: 'Es scheint, als sei dieser Token ungültig.',
            ValidationCaptchaException: 'Es scheint, als sein Google Captcha ungültig.',
            ValidationException: 'Es scheint, als seien einige der Felder ungültig.',
            InvalidAuthenticationException: 'Überprüfe deine E-Mail-Adresse oder Passwort und versuche es erneut.',
            MaxAttemptsException: 'Maximale Anzahl an Versuchen überschritten. ',
            ResourceNotFoundException: 'Anfrage nicht gefunden.',
            UserNotFoundException: 'Benutzer nicht gefunden.',
            SeekerNotFoundException: 'Diese E-Mail-Adresse ist uns nicht bekannt. Bitte überprüfe sie und versuche es erneut.',
            SeekerEmailResetNotFoundException: 'Es scheint, als sei der E-Mail-Token zum Zurücksetzen ungültig.',
            EmailTokenNotValidException: 'Es scheint, als sei dieser Token ungültig.',
            QueryException: 'Hier ist etwas schief gelaufen.',
            ServerErrorException: 'Hier ist etwas schief gelaufen.',
            UserConfirmationTokenNotFoundException: 'Es scheint, als sei dieser Token ungültig.',
            UserExistsException: 'Diese E-Mail-Adresse ist bereits vergeben.',
            JobNotFoundException: 'Es scheint, als sei dieser Job nicht mehr ausgeschrieben.',
            UserResumeNotFoundException: 'Es scheint, als würde dieser Lebenslauf nicht mehr exisitieren.',
            UserJobAlertNotFoundException: 'Es scheint, als würde diese Job Benachrichtigung nicht mehr existieren.',
            UserAppliedForJobException: 'Es scheint, als hättest du dich bereits auf diesen Job beworben.',
            PromotionNotFoundException: 'It seems this promotion is not exist.',
            SmartfeedJobTokenNotFoundException: 'The apply token is not valid.',
            InvalidPasswordException: 'Dein Passwort ist ungültig.',
            OwnEmailNotAllowedException: 'Du kannst deine aktuelle E-Mail-Adresse nicht ändern.',
            FileImageSizeException: 'Das Bild ist zu klein. Die minimale Bildgröße beträgt 150x150px.',
            FileSizeException: 'Diese Datei ist zu groß. Die maximale Dateigröße beträgt 20MB.',
            GoogleCaptchaException: 'Google Captcha konnte nicht validiert werden.',
            SeekerPasswordResetNotFoundException: 'Gib den Code noch mal ein und versuche es erneut.',
            InvalidFilterCriteria: 'Das ist zu weit gefasst. Bitte definiere einige Kriterien genauer.',
            PasswordResetTooManyAttempts: 'Das waren zu viele Versuche, das Passwort zurückzusetzen. Bitte versuche es in 20 Sekunden erneut.',
            PasswordTokenNotValid: 'Passwort Code ist nicht gültig.',
        },

        additional_document: {
            drag_and_drop_info: 'Drag & drop oder klicke, <br> um zusätzliche Dokumente hochzuladen.',
            file_type_info: 'Es sind nur .docx, .doc und .pdf Dateien zulässig.',
            max_document_size_info: 'Maximale Dateigröße für den Lebenslauf beträgt 10MB',
            not_found: 'Keine zusätzlich gespeicherten Dokumente',
            remove: 'Zusätzliche Dokumente entfernen?',
            title: 'Zusätzliche Dokumente',
            uploaded: 'Hochgeladen',
            uploaded_documents: 'Hochgeladene Dokumente',
        },

        application: {
            title: 'Bewerbungen',
            not_found: 'Keine Bewerbungen gefunden',
            view: 'Job ansehen',
        },

        apply: {
            apply_with_email_title: 'Oder bewirb dich mit deiner E-Mail-Adresse',
            apply_for_job: 'Bewerben',
            apply_as_guest: 'Als Gast bewerben',
            info: ' Wir erstellen automatisch ein Profil von dem Konto, mit dem du dich bewirbst',
            apply_with_email: 'Mit {email} bewerben',
            apply_with_linkedin: 'Mit LinkedIn bewerben',
            back: 'Zurück zur Job-Übersicht',
            confirmation: 'Eine Bestätigungs-E-Mail wurde gesendet an',
            job_application: 'Bewerbung',
            loading_resume: 'Dein Anschreiben wir hochgeladen. Bitte warte einen Augenblick...',
            success: 'Danke, dass du dich für diesen Job beworben hast.',
            title: 'Mit Accounts bewerben',
            register_and_apply: 'Registrieren und bewerben',
            application_already_received: 'Application already received',
        },

        cover_letter: {
            add: 'Anschreiben hinzufügen',
            apply_without: 'Ohne Anschreiben bewerben',
            drag_and_drop_info: 'Drag & drop oder klicke, <br> um ein Anschreiben hochzuladen.',
            edit: 'Anschreiben bearbeiten',
            file_type_info: ' Es sind nur .docx, .doc und .pdf Dateien zulässig.',
            max_document_size_info: 'Die maximale Dateigröße beträgt 10MB.',
            not_found: 'Keine gespeicherten Anschreiben',
            remove: 'Anschreiben entfernen?',
            title: 'Anschreiben',
            uploaded: 'Hochgeladen',
            uploaded_documents: 'Hochgeladene Anschreiben',
            write_new: 'Ein neues Anschreiben verfassen',
        },

        dashboard_menu: {
            applications: 'Bewerbungen',
            saved_jobs: 'Gespeicherte Jobs',
            job_alerts: 'Job Benachrichtigungen',
            profile_details: 'Profildetails',
            work_preferences: 'Work preferences',
            documents: 'Dokumente',
            account_settings: 'Account Einstellungen',
            logout: 'Abmelden',
        },

        filter: {
            clear_all: 'Alle löschen',
            info: 'Benutze die Suche oben, um mehr zu finden',
            see_less: 'Weniger anzeigen',
            see_all_value: 'Alle {value} Filter anzeigen',
        },

        forgot_password: {
            title: 'Passwort vergessen',
            info: 'Bitte gib deine E-Mail-Adresse ein und wir senden dir einen Code zum Zurücksetzen deines Passworts, falls ein Konto vorhanden ist.',
            resend_code: 'Hier klicken, um den Code erneut anzufordern',
            success: 'Wir haben dir einen Code zum Zurücksetzen deines Passworts an die untenstehende E-Mail gesendet. Bitte prüfe auch deinen Spam-Ordner.',
            success_resend_code: 'Wir haben dir einen Code zum Zurücksetzen deines Passworts an die untenstehende E-Mail gesendet. Bitte prüfe auch deinen Spam-Ordner.',
            try_again: 'Versuchen Sie es in {countDown} Sekunden erneut',
        },

        create_password: {
            title: 'Passwort erstellen',
            info: 'Willkommen zurück! Es scheint, als sei dein Passwort abgelaufen. Wir haben dir einen Code zum Zurücksetzen deines Passworts gesendet. Gib den Code unten ein und setze dein Passwort zurück.',
        },

        global: {
            currency_format: '{0} €',
            currency_symbol: '€',
        },

        job_alert: {
            create: 'Job Benachrichtigung erstellen',
            error: 'Momentan kann keine Job Benachrichtigung eingestellt werden. Bitte aktualisiere die Seite und versuche es erneut.',
            manage: 'Deine Job Benachrichtigungen verwalten',
            not_found: 'Keine gespeicherten Job Benachrichtigungen gefunden',
            remove: 'Diese Job Benachrichtigung entfernen?',
            save: 'Diese Job Benachrichtigung speichern',
            saved: 'Gespeicherte Job Benachrichtigungen',
            search_term: 'Suchbegriff',
            success: 'Deine Job Benachrichtigung wurde eingestellt. Vielen Dank.',
            success_remove: 'Ihre Jobbenachrichtigung wird entfernt. Danke',
            title: 'Job Benachrichtigungen',
        },

        job_view: {
            date_posted: 'Veröffentlichungsdatum',
            expired: 'Diese Stellenausschreibung ist abgelaufen',
            expired_desc: 'This job is no longer available. Please view our full list of jobs by clicking \'See more results\'.',
            posted_on: 'Veröffentlichungsdatum',
            see_desc: 'Stellenbeschreibung ansehen',
            hide_desc: 'Stellenbeschreibung ausblenden',
            other_jobs: 'Ähnliche Jobs',
        },

        single_job: {
            backToSearchUrl: 'Jobs',
            see_more_results: 'Mehr Ergebnisse anzeigen',
            see_more_results_2: 'Zurück zu allen Jobs',
        },

        label: {
            add_all: 'Add all {value} of interest to you',
            add_value: '{value} hinzufügen',
            additional_documents: 'Zusätzliche Dokumente',
            alert_name: 'Name der Benachrichtigung',
            alert_name_placeholder: 'Suchname eingeben',
            already_have_account: 'Du hast bereits einen Account?',
            annual_salary: 'Jahresgehalt',
            annualy: 'Jährlich',
            any: 'Any',
            any_value: 'Any {value}',
            applied: 'Applied',
            apply_again: 'Erneut bewerben',
            apply_as_guest: 'Als Gast bewerben',
            apply_now: 'Anwenden',
            availability: 'Verfügbarkeit',
            back: 'Zurück',
            back_to_value: 'Zurück zu {value}',
            base_pay: 'Grundgehalt',
            basic_information: 'Grundlegende Informationen',
            cancel: 'Abbrechen',
            career_level: 'Berufserfahrung',
            certifications: 'Zertifikate',
            change_email: 'E-Mail ändern',
            classification: 'Classification',
            classification_select: 'Select classifications from below',
            company: 'Unternehmen',
            company_placeholder: 'Gib den Unternehmensnamen ein',
            company_size: 'Unternehmensgröße',
            confirm_password: 'Passwort bestätigen',
            confirm_remove: 'Ja, entfernen',
            consultant: 'Consultant',
            contact_number: 'Kontaktnummer',
            contact_number_placeholder: 'Kontaktnummer angeben',
            continue_to_apply: 'Weiter bewerben',
            contract_type: 'Art der Beschäftigung | Art der Beschäftigungen',
            country: 'Country',
            country_of_citizenship: 'Country of citizenship',
            course_name: 'Course name',
            cover_letter: 'Anschreiben',
            cover_letter_custom_name: 'Gib einen benutzerdefinierten Namen für das Anschreiben ein',
            cover_letter_name: 'Name des Anschreibens',
            cover_letters: 'Anschreiben',
            create: 'Erstellen',
            create_job_alert: 'Job Benachrichtigung einstellen',
            create_password: 'Passwort erstellen',
            current_role: 'Aktuelle Rolle',
            daily: 'Täglich',
            date_posted: 'Veröffentlichungsdatum',
            delete_my_account: 'Meinen Account löschen',
            description: 'Beschreibung',
            desired_occupations: 'Gewünschter Beruf',
            desired_pay: 'Gewünschtes Gehalt',
            desired_work_locations: 'Gewünschte Arbeitsorte',
            dob: 'Geburtsdatum',
            dont_have_account: 'Du hast noch keinen Account?',
            download: 'Herunterladen',
            edit: 'Bearbeiten',
            edit_value: '{value} bearbeiten',
            education: 'Bildungsweg',
            email: 'E-Mail',
            email_address: 'E-Mail-Adresse',
            email_address_placeholder: 'E-Mail-Adresse angeben',
            email_alert_frequency: 'Häufigkeit der E-Mail-Benachrichtigungen',
            email_me_code: 'Code per E-Mail',
            email_to: 'E-Mail',
            emergency_contact_name: 'Notfall Kontaktname',
            emergency_contact_number: 'Notfall Kontakt Nummer',
            emergency_contact_rel: 'Notfallkontaktbeziehung',
            end_date: 'Enddatum',
            enter_code: 'Code eingeben',
            enter_current_password: 'Aktuelles Passwort eingeben',
            enter_current_password_for_email: 'Aktuelles Passwort eingeben, um E-Mail-Änderung zu bestätigen',
            enter_new_email: 'Neue E-Mail-Adresse eingeben',
            enter_new_password: 'Neues Passwort eingeben',
            enter_the_value: '{value} eingeben',
            enter_value: '{value} eingeben',
            enter_your_value: '{value} eingeben',
            enter_your_value_again: '{value} erneut eingeben',
            expires_at: 'Closing date',
            filters: 'Filter',
            find_jobs_now: 'Jetzt Jobs finden',
            first_name: 'Vorname',
            first_name_placeholder: 'Vorname eingeben',
            forgot_password: 'Passwort vergessen',
            frequency: 'Häufigkeit',
            gender: 'Geschlecht',
            go: 'Gehalt festlegen',
            home_location: 'Wohnsitz',
            hourly: 'Stündlich',
            hourly_rate: 'Stundensatz',
            in_progress: 'In Bearbeitung',
            industries: 'Branchen, in denen du arbeiten möchtest',
            institution_name: 'Institution name',
            job_mode: 'Job mode',
            job_title: 'Stellenbezeichnung',
            job_title_placeholder: 'Bitte gib deine Stellenbezeichnung ein, z.B. Buchhalter',
            job_type: 'Job type | Job types',
            job_type_placeholder: 'Select a job type',
            keyword: 'Stichwort | Stichworte',
            languages: 'Sprachen',
            last_name: 'Nachname',
            last_name_placeholder: 'Nachname eingeben',
            licenses_and_certifications: 'Zertifikate und Lizenzen',
            licenses_or_certifications: 'Zertifikate und Lizenzen',
            location: 'Ort',
            login: 'Anmelden',
            look_for_all_jobs: 'Look for all available jobs',
            max: 'Maximum',
            message: 'Nachricht',
            min: 'Minimum',
            mobile_number: 'Mobile number',
            mobile_number_placeholder: 'Enter mobile number',
            modified: 'Geändert',
            new_cover_letter_details: 'Neue Details zum Anschreiben',
            no_industries: 'Ich habe keine Präferenz bezüglich der Branche',
            no_job_mode: 'I have no job mode preference',
            not_added_value: 'No {value} added',
            not_found: 'Nicht gefunden',
            null_pay_included: 'Schließen Sie Jobs ein, die keine Gehaltsdetails haben',
            occupation: 'Beruf',
            occupation_placeholder: 'Gib alle Berufe an, die dich interessieren',
            off: 'Aus',
            password: 'Passwort',
            payband_placehoder: 'Wähle den nächstgelegenen Wert',
            per_day: 'Pro Tag',
            perks_and_benefits: 'Vergünstigungen & Vorteile',
            phone_number: 'Phone number',
            phone_number_placeholder: 'Enter phone number',
            placeholder_email: 'E-Mail',
            placeholder_password: 'Passwort',
            position: 'Position',
            position_placeholder: 'Enter position',
            print: 'Drucken',
            profession: 'Beruf',
            profile_picture: 'Profilbild',
            qualification_type: 'Art der Qualifikation',
            range: 'Range',
            recover_password: 'Passwort wiederherstellen',
            reference: 'Verweise',
            reference_number: 'Referenznummer',
            register: 'Registrieren',
            relevance: 'Relevanz',
            remove: 'Entfernen',
            required_value: 'Das {value} Feld ist ein Pflichtfeld',
            reset: 'Zurücksetzen',
            reset_password: 'Passwort zurücksetzen',
            resumes: 'Lebensläufe',
            salary: 'Gehalt',
            salary_type: 'Gehaltstyp',
            salary_currency: 'Gehaltswährung',
            salary_any_currency: 'Jede Währung',
            save: 'Speichern',
            save_cover_letter: 'Anschreiben speichern',
            save_job: 'Job speichern',
            save_value: '{value} speichern',
            save_work_experience: 'Berufserfahrung speichern',
            search_by_location: 'Nach Ort, Bundesland oder Region suchen',
            search_jobs: 'Suchen',
            search_keyword: 'Stichwort eingeben',
            search_within_value: 'Zwischen {value1} {value2} suchen',
            sector: 'Bereich',
            select_location: 'Alle Orte',
            select_value: '{value} auswählen',
            share: 'Teilen',
            sign_in: 'Anmelden',
            sign_in_and_apply: 'Anmelden und bewerben',
            skills: 'Fähigkeiten',
            sort_by: 'Sortieren nach',
            start_date: 'Startdatum',
            start_end_dates: 'Start- und Enddaten',
            sub_classification: 'Sub classification',
            sub_classification_select: 'Select subclassifications',
            submit: 'Submit',
            suburb_city_area: 'Ort, Bundesland oder Region',
            unsave: 'Speicherung aufheben',
            upload_file_size: 'File size 10MB max',
            upload_label: 'Tap to upload document',
            upload_new: 'Upload new',
            upload_new_additional_document: 'Neues zusätzliches Dokument hochladen',
            upload_new_cover_letter: 'Neues Anschreiben hochladen',
            upload_new_resume: 'Neuen Lebenslauf hochladen',
            upload_profile_picture: 'Profilbild hochladen',
            uploaded: 'Uploaded',
            uploaded_document: 'Uploaded document',
            uploaded_now: 'just now',
            view_job: 'Job ansehen',
            weekly: 'Wöchentlich',
            what_is_this: 'Was ist das',
            what_is_this_occupation: 'Dieser Beruf wird verwendet, um Ihre Job-Empfehlungen anzupassen. Bitte wählen Sie den Beruf aus, der am besten mit der Stellenbezeichnung übereinstimmt.',
            work_authorisation: 'Arbeitsgenehmigung',
            work_experience: 'Berufserfahrung',
            work_location: 'Arbeitsort',
            work_occupation_placeholder: 'Geben Sie Ihre berufliche Tätigkeit ein',
            work_preferences: 'Work preferences',
            work_type: 'Anstellungsart',
            write_a_cover_letter: 'Verfasse ein Anschreiben',
            write_cover_letter: 'Anschreiben verfassen',
        },

        login: {
            welcome_back: 'Willkommen zurück',
            welcome: 'Wilkommen!',
            title: 'Anmeldung',
            info: '',
            back: 'Zurück zur Anmeldung',
        },

        profile: {
            basic_information: 'Grundlegende Informationen',
            not_found_location: 'Wir unterstützen derzeit keine Stellenangebote an diesem Standort. Bitte kontaktieren Sie uns, um einen neuen Standort anzufordern.',
            not_found_global_location: 'Keine übereinstimmenden Standorte gefunden. Bitte versuchen Sie eine andere Suche oder wählen Sie das Land als Ort aus.',
            pay_info: 'Deine Gehaltsangaben helfen uns, deinen beruflichen Werdegang besser zu verstehen, sodass wir uns darauf konzentrieren können, deine Karriere voranzubringen.',
            profile_details: 'Profile-Details',
        },

        register: {
            welcome: 'Willkommen',
            welcome_aboard: 'Schön, dass du da bist!',
            info: '',
            back: 'Zurück zur Registrierung',
        },

        reset_email: {
            title: 'E-Mail zurücksetzen',
            success: 'Deine E-Mail wurde erfolgreich zurückgesetzt',
        },

        reset_password: {
            title: 'Passwort erstellen',
            info: 'Bitte gib die deinem Account zugehörige E-Mail-Adresse und ein neues Passwort ein.',
            success: 'Du hast erfolgreich ein neues Passwort erstellt!',
        },

        resume: {
            apply_without: 'Ohne Lebenslauf bewerben',
            default: 'Standard Lebenslauf',
            dropbox_title: 'Über Dropbox hochladen',
            default_option: 'Als Standard für zukünftige Bewerbungen festlegen',
            default_text: 'Wähle Lebenslauf-Option',
            drag_and_drop_info: 'Drag & drop oder klicke, <br> um einen Lebenslauf hochzuladen.',
            drag_and_drop_size: '(Dateigröße maximal 10MB)',
            file_type_info: 'Nur pdf, docx, doc, rtf, txt, odt, pages (maximal 10MB)',
            googledrive_title: 'Über Google Drive hochladen',
            max_resume_size_info: 'Die maximale Dateigröße beträgt 10MB',
            new: 'Neuen Lebenslauf hochladen',
            not_found: 'Keine Lebensläufe hochgeladen',
            remove: 'Lebenslauf entfernen?',
            title: 'Lebensläufe',
            upload_documents: 'Dokumente hochladen',
            upload: 'Lebensläufe hochladen',
            uploaded: 'Hochgeladen',
            uploaded_resumes: 'Lebenslauf auswählen',
            upload_via: 'Über {service} hochladen',
            ducment_uploaded: 'Dokument hochgeladen',
        },

        saved_job: {
            saved_jobs: 'Gespeicherte Jobs',
            not_found: 'Keine gespeicherten Jobs gefunden',
        },

        search_results: {
            not_found: 'Entschuldige, für diese Suchkriterien wurden keine Jobs gefunden.',
            showing: 'Zeigt',
            separator: 'bis',
            of: 'von',
            results: 'Ergebnisse',
            listView: 'Listenansicht',
            mapView: 'Kartenansicht',
            mapViewLocation: 'Standort',
            mapViewRadius: 'Innerhalb (KM)',
            mapViewUpdate: 'Karte aktualisieren',
            mapViewReset: 'Karte zurücksetzen',
        },

        share: {
            facebook: 'Post',
            linkedin: 'Share',
            title: 'Teilen mit',
            twitter: 'Tweet',
        },

        terms: {
            link: 'Beim Fortfahren mit dieser Bewerbung stimmst du unseren',
            terms: 'Nutzungsbedingungen',
            and: 'und',
            privacy: 'Datenschutzrichtlinien zu.',
            validation_message: 'Bitte stimme unseren Geschäftsbedingungen zu.',
        },

        work_preferences: {
            work_preferences: 'Work Preferences',
            next_role: 'Deine nächste Rolle',
            other: 'Andere Präferenzen',
            job_type: 'Job Type',
            contract_type: 'Art der Beschäftigung',
        },

        work_experience: {
            add: 'Berufserfahrung hinzufügen?',
            edit: 'Berufserfahrung bearbeiten?',
            remove: 'Berufserfahrung entfernen',
        },

        education: {
            add: 'Abschluss hinzufügen',
            remove: 'Abschluss entfernen',
        },

        reference: {
            add: 'Add referee',
            remove: 'Remove referee',
        },

        searchbar: {
            keywords_label: 'Stichworte',
            classifications_label: 'Classifications',
            classification_placeholder: 'in all classifications',
            locations_label: 'Orte',
        },

        screening: {
            confirm_and_finish: 'Confirm and finish',
            title: 'Complete additional questions',
            sub_title: 'Improve your chances of being considered for this job by completing the below questions',
        },

        networks: {
            facebook: {
                shareText: 'Post',
            },
            twitter: {
                shareText: 'Tweet',
            },
            linkedin: {
                shareText: 'Share',
            },
        },
    },
};

export default messages;
